<template>
    <form @submit="onSubmit">
    <div class="shipping-addr" v-if="lang=='fr'">
        <div class="progress">
            <h1>Votre Panier</h1>
            <div>Votre commande</div>
            <div class="active">Facturation et livraison</div>
            <div>Récapitulatif</div>
        </div>
        <div>
            <div class="info">
                <strong>Adresse de livraison</strong><br />
                <span>Merci de remplir le formulaire ci-dessous.</span>

            </div>

            <div class="form">
                <ul>
                    <li>
                        <label></label>
                        Utilisez l'adresse de facturation <button class="focus" @click="copyAddress()">Cliquez ici</button>
                    </li>
                    <li>
                        <label>Nom :</label>
                        <select v-model="shippingAddress.gender" required>
                            <option v-for="gender in all_genders" :value="gender.type">{{ gender.fr }}</option>
                        </select>
                        <input type="text" required v-model="shippingAddress.lname" />
                    </li>
                    <li>
                        <label>Prénom :</label>
                        <input type="text" required v-model="shippingAddress.fname" />
                    </li>
                    <li>
                        <label>Société :</label>
                        <input type="text" v-model="shippingAddress.company" />
                    </li>
                    <li class="address">
                        <label>Adresse : </label>
                        <textarea required v-model="shippingAddress.address"></textarea>
                    </li>
                    <li>
                        <label>Code Postal : </label>
                        <input required type="text" v-model="shippingAddress.postcode" />
                        <span class="city">Ville : </span>
                        <input type="text" v-model="shippingAddress.city" />
                    </li>
                    <li>
                        <label>Pays :</label>
                        <select v-model="shippingAddress.country">
                            <option v-for="country in all_countries" :value="country.type">{{ country.fr }}</option>
                        </select><span class="other-country">Pour tout autre pays, contactez directement AIM</span>
                    </li>
                    <li>
                        <label class="empty">Aide à la livraison :<br/><small>Merci d'indiquer ci-contre toute information utile pour faciliter la livraison : Code porte, Bâtiment, étages, etc...</small></label>
                        <textarea type="text" v-model="shippingAddress.observation"  />
                    </li>
                    <li>
                        <label>N° de téléphone pour la livraison :<br /><small>Cette information est obligatoire pour assurer la livraison</small></label>
                        <input required type="text" v-model="shippingAddress.phone" />
                    </li>
                    <li>
                        <label>Est-ce pour offrir ? :</label>
                        <input type="radio" value="1" v-model="shippingAddress.is_gift" />Oui
                        <input type="radio" value="0" v-model="shippingAddress.is_gift" />Non
                    </li>
                    <li v-if="shippingAddress.is_gift > 0">
                        <label>Souhaitez-vous ajouter un mot à votre colis ?</label>
                        <textarea v-model="shippingAddress.giftMessage" />
                    </li>
                </ul>
            </div>
        </div>
        <section class="actions">
            <button @click="prevStep()" class="prev submit focus">Retour</button>
            <button @click="nextStep()" class="next submit focus">Valider</button>
        </section>
    </div>

    <div class="shipping-addr" v-else>
        <div class="progress">
            <h1>Your shipping cart</h1>
            <div>Your order</div>
            <div class="active">Billing and Shipping Addresses</div>
            <div>Summary</div>
        </div>
        <div class="client-page">
            <p>
                <strong>Shipping Address</strong><br />
                Thank you for filling out the form bellow.<br />
            </p>

            <div class="form">
                <ul>
                    <li>
                        <label></label>
                        Use billing address<button class="focus">Cliquez ici</button>
                    </li>
                    <li>
                        <label>Last Name :</label>
                        <select v-model="shippingAddress.gender" required>
                            <option v-for="gender in all_genders" :value="gender.type">{{ gender.en }}</option>
                        </select>
                        <input type="text" required v-model="shippingAddress.lname" />
                    </li>
                    <li>
                        <label>First name :</label>
                        <input type="text" required v-model="shippingAddress.fname" />
                    </li>
                    <li>
                        <label>Company :</label>
                        <input type="text" v-model="shippingAddress.company" />
                    </li>
                    <li class="address">
                        <label>Address : </label>
                        <textarea required v-model="shippingAddress.address"></textarea>
                    </li>
                    <li>
                        <label>Zip Code: </label>
                        <input required type="text" v-model="shippingAddress.postcode" />
                        <span class="city">City : </span>
                        <input type="text" v-model="shippingAddress.city"/>
                    </li>
                    <li>
                        <label>Country :</label>
                        <select required v-model="shippingAddress.country">
                            <option v-for="country in all_countries" :value="country.type">{{ country.en }}</option>
                        </select><span class="other-country">For any other country, please contact Amelie</span>
                    </li>
                    <li>
                        <label class="empty">Delivery Useful Information :<br/><small>To enjoy a satisfying delivery experience: thanks for adding any relevant information to this field: building security keypad, building number, floor, etc</small></label>
                        <textarea type="text" v-model="shippingAddress.observation" />
                    </li>
                    <li>
                        <label>Telephone Number for delivery:<br /><small>This information is required to ensure effective delivery</small></label>
                        <input required type="text" v-model="shippingAddress.phone"/>
                    </li>
                    <li>
                        <label>Is it a gift ? :</label>
                        <input type="radio" value="1" v-model="shippingAddress.is_gift" />Yes
                        <input type="radio" value="0" v-model="shippingAddress.is_gift" />No
                    </li>
                    <li v-if="shippingAddress.is_gift > 0">
                        <label>Would you like to add a gift message ?</label>
                        <textarea v-model="shippingAddress.giftMessage" />
                    </li>
                </ul>

            </div>
        </div>
        <section class="actions">
            <button @click="prevStep()" class="prev submit focus">Back</button>
            <button @click="nextStep()" class="next submit focus">Submit</button>
        </section>
    </div>
    </form>
</template>

<script>
  import { mapGetters } from 'vuex';

  export default {
    name: 'Client',
    props: ['lang'],
    data() {
      return {
        goingBack: false,
        all_genders: [
          { type: 'M', fr: 'Mr', en: 'Mr.' },
          { type: 'Mme', fr: 'Mme', en: 'Mrs' },
          { type: 'Mlle', fr: 'Mlle', en: 'Ms.' },
        ],
        all_countries: [
          { type: 'FR', fr: 'France métropolitaine', en: 'France' },
          { type: 'GB', fr: 'Royaume Uni', en: 'United Kingdom' },
          { type: 'IT', fr: 'Italie', en: 'Italy' },
          { type: 'DE', fr: 'Allemagne', en: 'Germany' },
          { type: 'ES', fr: 'Espagne', en: 'Spain' },
          { type: 'CH', fr: 'Suisse', en: 'Switzerland' },
          { type: 'AT', fr: 'Autriche', en: 'Austria' },
          { type: 'SE', fr: 'Suède', en: 'Sweden' },
          { type: 'NO', fr: 'Norvège', en: 'Norway' },
        ],
      };
    },
    computed: {
      ...mapGetters([
        'billingAddress',
        'shippingAddress',
      ]),
    },
    methods: {
      prevStep() {
        this.goingBack = true;
        const routes = this.$router.options.routes;
        const routeToUser = this.$router.options.getRouteByName(routes, `Billing${this.lang.toUpperCase()}`);
        if (routeToUser) {
          this.$router.push(routeToUser);
        }
      },
      nextStep() {
        this.goingBack = false;
        if (!this.checkForm()) {
          return;
        }

        this.$store.commit('updateShippingAddress', this.shippingAddress);

        const routes = this.$router.options.routes;
        const routeToUser = this.$router.options.getRouteByName(routes, `Summary${this.lang.toUpperCase()}`);
        if (routeToUser) {
          this.$router.push(routeToUser);
        }
      },
      onSubmit(e) {
        e.preventDefault();

        if (this.checkForm() && !this.goingBack) {
          this.nextStep();
        }
      },
      checkForm() {
        this.errors = [];

        if (!this.shippingAddress.gender) {
          this.errors.push(this.lang === 'fr' ? 'Genre' : 'Gender');
        }

        if (!this.shippingAddress.fname) {
          this.errors.push(this.lang === 'fr' ? 'Prénom' : 'First name');
        }

        if (!this.shippingAddress.lname) {
          this.errors.push(this.lang === 'fr' ? 'Nom' : 'Last name');
        }

        if (!this.shippingAddress.address) {
          this.errors.push(this.lang === 'fr' ? 'Adresse' : 'Address');
        }

        if (!this.shippingAddress.postcode) {
          this.errors.push(this.lang === 'fr' ? 'Code postal' : 'Zip code');
        }

        if (!this.shippingAddress.country) {
          this.errors.push(this.lang === 'fr' ? 'Pays' : 'Country');
        }

        if (!this.shippingAddress.phone) {
          this.errors.push(this.lang === 'fr' ? 'Téléphone' : 'Phone');
        }

        if (this.errors.length === 0) {
          return true;
        }
        return false;
      },
      updateField() {
        this.$store.commit('updateShippingAddress', this.shippingAddress);
      },
      copyAddress() {
        this.$store.commit('copyBillingAddress');
      },
    },
  };
</script>


<style lang="scss">
    .shipping-addr {
        padding: 2rem !important;
        max-width: 900px;
        background: url('../assets/checkout_bg.png') no-repeat top;
        background-size: cover;
        margin:auto;
        color: #654a45;

        .progress {
            color:white;
            counter-reset: progress-counter;

            @media (max-width:42rem) {
                padding-top:2rem;
            }

            h1 {
                color:white;
                text-transform: uppercase;
                text-shadow: 1px 1px #333;
                display: inline-block;
            }
            > div {
                display: inline-block;
                padding:.5rem 1rem;

                &.active {
                    color:#9c554b;
                }

                &:before{
                    counter-increment: progress-counter +1;
                    content: counter(progress-counter) ;
                    background-color: white;
                    color: #654a45;
                    padding:0.1rem .5rem;
                    border-radius:50%;
                    border:1px gray solid;
                    margin-right:0.5rem;
                }
            }
        }

        .form {
            .other-country {
                font-size:0.8rem;
                margin-left:0.5rem;
                width: 140px;
                line-height: 0.7rem;
                vertical-align: middle;
                display: inline-block;
            }

            ul {
                margin:auto;
                padding:0;
                list-style: none;
            }

            @media (min-width: 42em) {
                display: flex;
                flex: 100%;

                input, select {
                    line-height: 1rem;
                    overflow: hidden;
                }
                li {
                    &:nth-of-type(2) input {width:238px}
                    &:nth-of-type(3) input,
                    &:nth-of-type(4) input,
                    &:nth-of-type(7) input,
                    &:nth-of-type(8) input {width:310px;}

                    &:nth-of-type(6) {
                        input:nth-of-type(1){width:80px;}  // zip
                        input:nth-of-type(2) {;width:174px;}  // city
                    }
                }
                textarea {width:320px; height:80px;}

                label {
                    vertical-align: top;
                    display: inline-block;
                    width :230px;
                    text-align: right;
                    margin-right:0.5rem;

                    small {
                        font-size:0.8rem;
                        line-height: 0.8rem;
                        display: inline-block;
                    }
                }
            }

            @media (max-width: 42em) {      // vue smartphone
                li {
                    white-space: nowrap;

                    small {
                        white-space: normal;
                        display: inlin;
                        line-height: 0.8rem;
                    }
                }
                span.city {
                    display: block;
                    margin-top:0.5rem;
                }
                label {
                    display: block;
                    margin-top:0.5rem;
                }
                li {
                    input[type='text'], textarea, select {
                        width:100%;
                        display: block;
                    }
                    select {
                        display: block;
                    }

                    &:nth-of-type(2) select {width:auto; }
                }
            }
        }


        section.actions {
            display: block;
            height: 1rem;
            margin-top:1rem;
            .submit.next {
                float: right;
            }
            .submit.prev {
                float: left;
            }
        }
    }

</style>



// WEBPACK FOOTER //
// src/components/ShippingAddressPage.vue